import BackOffice from '@/pages/statistics/BackOffice.vue'

export default [
  {
    path: '/backoffice/',
    alias: [],
    component: BackOffice
  }
]



// WEBPACK FOOTER //
// ./src/routes/services/commonRoutes.js